import { render, staticRenderFns } from "./FrzProductionGroup.vue?vue&type=template&id=4f9c78b2"
import script from "./FrzProductionGroup.vue?vue&type=script&lang=js"
export * from "./FrzProductionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports